import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CButton, CFormText } from '@coreui/react'
import { Dropdown } from 'react-bootstrap'
import themeIcon from '../../../assets/theme-editor.svg'
import CloseIcon from '../../../assets/editor-close-icon.svg'
import MagentaIcon from '../../../assets/magenta-icon.svg'
import NeonDarkIcon from '../../../assets/neon-dark-icon.svg'
import PantoneRedIcon from '../../../assets/pantone-red-icon.svg'
import DarkInfraIcon from '../../../assets/dark-infra-red.svg'
import GreenEnergyIcon from '../../../assets/green-energy.svg'
import DefaultThemeIcon from '../../../assets/default-theme-icon.svg'
import GreenTick from '../../../assets/green-tick.svg'
import { GlobalContext } from 'src/views/context/GlobalState'
import RosemaryToptrendingModal from 'src/components/template/rosemary/rosemaryToptrendingModal'
import { isEmpty } from 'lodash'
import RosemaryHeaderModal from 'src/components/template/rosemary/rosemaryHeaderModal'
import RosemaryMomentModal from 'src/components/template/rosemary/rosemaryMomentModal'
import RosemaryFooterModal from 'src/components/template/rosemary/rosemaryFooterModal'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import RosemaryCarouselModal from 'src/components/template/rosemary/rosemaryCarouselModal'
import RosemaryRecentStoriesModal from 'src/components/template/rosemary/rosemaryRecentStoriesModal'
import uuid from 'react-uuid'
import { ThemeProvider } from 'theming'
import magentaHighlight from '../themes/magentaHighlight'
import neonDark from '../themes/neonDark'
import pantoneRed from '../themes/pantoneRed'
import darkInfraRed from '../themes/darkInfraRed'
import greenEnergy from '../themes/greenEnergy'
import defaultTheme from '../themes/defaultTheme'
import useAxios from 'axios-hooks'
import { BASE_COMPONENTS, TEMPLATE_V2_URL } from '../../utils/urls'
import { AppContext } from '../../context/app'
import RosemaryCategoriesModal from 'src/components/template/rosemary/rosemaryCategoriesModal'
import FitnessHeaderModal from 'src/components/template/fitness/fitnessHeaderModal'
import FitnessFooterModal from 'src/components/template/fitness/fitnessFooterModal'
import FitnessYogaAdModal from 'src/components/template/fitness/fitnessYogaAdModal'
import FitnessClassesModal from 'src/components/template/fitness/fitnessClassesModal'
import FitnessPlansModal from 'src/components/template/fitness/fitnessPlansModal'
import FitnessHeroModal from 'src/components/template/fitness/fitnessHeroModal'
import FitnessGalleriesModal from 'src/components/template/fitness/fitnessGalleriesModal'
import FitnessPackagesModal from 'src/components/template/fitness/fitnessPackagesModal'
import FitnessTrainerModal from 'src/components/template/fitness/fitnessTrainerModal'
// import * as htmlToImage from 'html-to-image'
import AddSectionModal from 'src/components/template/addSectionModal'
import OpaqueHeader from 'src/components/template/rosemary/opaqueHeader'
import RowingHeroSection from 'src/components/template/rosemary/rowingHeroSection'
import AsymmetricFlow from 'src/components/template/rosemary/asymmetricFlow'
import PromotionalLead from 'src/components/template/rosemary/promotionalLead'
import PassimCarve from 'src/components/template/rosemary/passimCarve'
import InventorySlide from 'src/components/template/rosemary/inventorySlide'
import ParallelFooter from 'src/components/template/rosemary/parallelFooter'
import CrystallineHeader from 'src/components/template/fitness/crystallineHeader'
import ClassyBanners from 'src/components/template/fitness/classyBanners'
import NarrowAdmonition from 'src/components/template/fitness/narrowAdmonition'
import DefinityCards from 'src/components/template/fitness/definityCards'
import FineTunedGallery from 'src/components/template/fitness/fineTunedGallery'
import FlyerIntro from 'src/components/template/fitness/flyerIntro'
import MementoSlides from 'src/components/template/fitness/mementoSlides'
import WedgedInfo from 'src/components/template/fitness/wedgedInfo'
import ConventionalFooter from 'src/components/template/fitness/ConventionalFooter'
import DecomposedBanners from 'src/components/template/gaming/decomposedBanners'
import AdNCarousel from 'src/components/template/gaming/adNCarousel'
import ExtensiveCarouselRendition from 'src/components/template/gaming/extensiveCarouselRendition'
import ExtensiveCarouselSimple from 'src/components/template/gaming/extensiveCarouselSimple'
import BobbingCards from 'src/components/template/gaming/bobbingCards'
import ShadowBGFooter from 'src/components/template/gaming/shadowBGFooter'
import DecomposedBannersModal from 'src/components/template/gaming/decomposedBannersModal'
import ExtensiveCarouselRenditionModal from 'src/components/template/gaming/extensiveCarouselRenditionModal'
import AdNCarouselModal from 'src/components/template/gaming/adNCarouselModal'
import ExtensiveCarouselSimpleModal from 'src/components/template/gaming/extensiveCarouselSimpleModal'
import ShadowBGFooterModal from 'src/components/template/gaming/shadowBGFooterModal'
import BobbingCardsModal from 'src/components/template/gaming/bobbingCardsModal'
import TripleCardCarousel from 'src/components/template/gaming/tripleCardCarousel'
import TripleCardCarouselModal from 'src/components/template/gaming/tripleCardCarouselModal'
// import DefaultHeader from 'src/components/template/default/defaultHeader'
// import DefaultHeaderModal from 'src/components/template/default/defaultHeaderModal'
import DefaultBanner from 'src/components/template/default/defaultBanner'
import DefaultBannerModal from 'src/components/template/default/defaultBannerModal'
import DefaultSwimlane from 'src/components/template/default/defaultSwimlane'
import DefaultSwimlaneModal from 'src/components/template/default/defaultSwimlaneModal'
import UImediaFooter from 'src/components/template/uimedia/uimediaFooter'
import UImediaFooterModal from 'src/components/template/uimedia/uimediaFooterModal'
import DefaultFooter from 'src/components/template/default/defaultFooter'
import DefaultFooterModal from 'src/components/template/default/defaultFooterModal'
import UIMediaHeader from 'src/components/template/uimedia/uiMediaHeader'
import UIMediaHeaderModal from 'src/components/template/uimedia/uiMediaHeaderModal'
import ATGHeader from 'src/components/template/atg/atgHeader'
import ATGHeaderModal from 'src/components/template/atg/atgHeaderModal'
import DefaultArtistSwimlane from 'src/components/template/default/defaultArtistSwimlane'
import DefaultVenueSwimlane from 'src/components/template/default/defaultVenueSwimlane'
import DefaultArtistSwimlaneModal from 'src/components/template/default/defaultArtistSwimlaneModal'
import DefaultVenueSwimlaneModal from 'src/components/template/default/defaultVenueSwimlaneModal'
import MiamiFoxHeader from 'src/components/template/miamiFox/miamiFoxHeader'
import MiamiFoxFooter from 'src/components/template/miamiFox/miamiFoxFooter'
import MiamiFoxHeaderModal from 'src/components/template/miamiFox/miamiFoxHeaderModal'
import PassimCarvePlayer from 'src/components/template/rosemary/passimCarvePlayer'
import PassimCarvePlayerModal from 'src/components/template/rosemary/passimCarvePlayerModal'
import ClassBannerPlayer from 'src/components/template/fitness/classBannerPlayer'
import ClassyBannerPlayerModal from 'src/components/template/fitness/classyBannerPlayerModal'
import DefaultBannerPlayer from 'src/components/template/default/defaultBannerPlayer'
import DefaultBannerPlayerModal from 'src/components/template/default/defaultBannerPlayerModal'

const themes = [defaultTheme, magentaHighlight, neonDark, pantoneRed, darkInfraRed, greenEnergy]

const TemplateEditor = () => {
  const templateRef = useRef(null)
  const location = useLocation()
  const history = useHistory()
  let { templateId } = useParams()
  const { setLoader, accountObj } = useContext(AppContext)
  const { signedIn } = useContext(GlobalContext)
  let customerId = localStorage.getItem('customer_id')
  let sessionId = localStorage.getItem('sessionId')
  const [modalState, setModalState] = useState({})
  console.log('modalStatemodalStatemodalState', modalState)
  const [isEdit, setIsEdit] = useState(true)
  const [deleteModal, setDeleteModal] = useState(false)
  const [editorCloseModal, setEditorCloseModal] = useState(false)
  const [addModalState, setAddModalState] = useState({})
  const [selectedComponentId, setSelectedComponentId] = useState('')
  const [themeIndex, setThemeIndex] = useState(0)
  const [templateData, setTemplateData] = useState({})
  const [premiumComponentExist, setPremiumComponentExist] = useState(false)

  const [componentData, setComponentData] = useState([])

  const [{ data: templateList, loading: templateListLoading }, templateListCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: baseComponentList, loading: baseComponentLoading }, baseComponentCall] = useAxios(
    {
      url: BASE_COMPONENTS,
      method: 'get',
    },
    { manual: true },
  )

  const [{ loading: updateTemplateLoading }, updateTemplateCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(templateListLoading || updateTemplateLoading || baseComponentLoading)
  }, [templateListLoading, updateTemplateLoading, baseComponentLoading])

  useEffect(() => {
    if (templateList && templateList.success) {
      let particularTemplateData = templateList?.data[0]
      if (!isEmpty(particularTemplateData)) {
        setTemplateData(particularTemplateData)
        setComponentData(particularTemplateData?.components)

        let tempThemeIndex = themes.findIndex(
          (info) => info.name === particularTemplateData?.selected_theme?.name,
        )

        if (tempThemeIndex > -1) {
          setThemeIndex(tempThemeIndex)
        }
      } else {
        history.push('/templates')
      }
    }
  }, [templateList])

  useEffect(() => {
    if (!customerId || !sessionId || !signedIn) {
      history.push({ pathname: '/login', state: location.pathname })
    } else {
      getTemplateData()
    }
    if (!templateId) {
      history.push('/')
    }
  }, [])

  useEffect(() => {
    if (location.pathname === '/template-preview') {
      setIsEdit(false)
    }
  }, [])

  useEffect(() => {
    checkPremiumComponent()
  }, [componentData])

  const checkPremiumComponent = () => {
    const componentIdArr = componentData.map((info) => info._id)

    let uniqueArr = componentIdArr.filter(function (obj) {
      return accountObj?.allowed_components.indexOf(obj) == -1
    })

    if (uniqueArr.length > 0) {
      setPremiumComponentExist(true)
      return
    }
    setPremiumComponentExist(false)
  }

  const checkPremiumComponentId = (componentId) => {
    return !isEmpty(accountObj?.allowed_components)
      ? !accountObj?.allowed_components.includes(componentId)
      : true
  }

  const getTemplateData = async () => {
    if (templateId) {
      templateListCall({
        params: {
          template_id: templateId,
        },
      })

      baseComponentCall()
    } else {
      history.push('/templates')
    }
  }

  const updateTemplate = async (data) => {
    if (!isEmpty(templateData)) {
      await updateTemplateCall({
        params: {
          template_id: templateData?._id,
        },
        data: data,
      })
      if (data.is_published) {
        templateListCall({
          params: {
            template_id: templateId,
          },
        })
      }
    }
  }
  const onSwap = (componentId, operation) => {
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)

    if (componentIndex < 0) return

    if (operation === 'up' && componentIndex > 0) {
      setComponentData((prevState) => {
        let data = [...prevState]

        let temp = data[componentIndex - 1]
        data[componentIndex - 1] = data[componentIndex]
        data[componentIndex] = temp

        return [...data]
      })
    }
    if (operation === 'down' && componentIndex < componentData.length - 1) {
      setComponentData((prevState) => {
        let data = [...prevState]

        let temp = data[componentIndex + 1]
        data[componentIndex + 1] = data[componentIndex]
        data[componentIndex] = temp

        return [...data]
      })
    }
  }

  const onDeleteComponent = () => {
    setComponentData((prevState) =>
      prevState.filter((info) => info.data.id !== selectedComponentId),
    )
    setSelectedComponentId('')
    setDeleteModal(false)
  }
  const handleDelete = (componentId) => {
    setSelectedComponentId(componentId)
    setDeleteModal(true)
  }

  const onCopy = (componentId) => {
    const componentInfo = componentData.find((info) => info.data?.id === componentId)
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)
    let tempComponentArr = componentData
    if (componentIndex > -1 && componentInfo) {
      let newComponentObj = JSON.parse(
        JSON.stringify({
          ...componentInfo,
          data: {
            ...componentInfo.data,
            id: uuid(),
          },
        }),
      )

      tempComponentArr.splice(componentIndex + 1, 0, newComponentObj)
    }
    setComponentData([...tempComponentArr])
  }

  // const downloadImage = async () => {
  //   const imageUrl = await htmlToImage.toPng(templateRef.current)
  //   console.log('dataUrl', imageUrl)

  //   // let blob = await fetch(
  //   //   'https://d1pg44wvryhaci.cloudfront.net/public/images/infinity_film_banner1667415386298.png',
  //   //   { mode: 'no-cors' },
  //   // ).then((r) => r.blob())
  //   // console.log('blob', blob)
  //   // debugger
  //   // download image
  //   const link = document.createElement('a')
  //   link.download = 'html-to-img.png'
  //   link.href = imageUrl
  //   link.click()
  // }

  const getComponent = (key, data) => {
    let componentProps = {
      componentData: data,
      modifyData: modifyComponent,
      setModalState: setModalState,
      isEdit: isEdit,
      onSwap: onSwap,
      onDelete: handleDelete,
      onCopy: onCopy,
      onAdd: setAddModalState,
    }
    let componentObj = {
      opaqueHeader: <OpaqueHeader {...componentProps} />,
      rowingHeroSection: <RowingHeroSection {...componentProps} />,
      asymmetricFlow: <AsymmetricFlow {...componentProps} />,
      promotionalLead: <PromotionalLead {...componentProps} />,
      passimCarve: <PassimCarve {...componentProps} />,
      passimCarvePlayer: <PassimCarvePlayer {...componentProps} />,
      inventorySlide: <InventorySlide {...componentProps} />,
      parallelFooter: <ParallelFooter {...componentProps} />,
      crystallineHeader: <CrystallineHeader {...componentProps} />,
      classyBanners: <ClassyBanners {...componentProps} />,
      classyBannersPlayer: <ClassBannerPlayer {...componentProps} />,
      narrowAdmonition: <NarrowAdmonition {...componentProps} />,
      definityCards: <DefinityCards {...componentProps} />,
      fineTunedGallery: <FineTunedGallery {...componentProps} />,
      flyerIntro: <FlyerIntro {...componentProps} />,
      mementoSlides: <MementoSlides {...componentProps} />,
      wedgedInfo: <WedgedInfo {...componentProps} />,
      conventionalFooter: <ConventionalFooter {...componentProps} />,
      decomposedBanners: <DecomposedBanners {...componentProps} />,
      extensiveCarouselRendition: <ExtensiveCarouselRendition {...componentProps} />,
      adNCarousel: <AdNCarousel {...componentProps} />,
      extensiveCarousel: <ExtensiveCarouselSimple {...componentProps} />,
      tripleCardCarousel: <TripleCardCarousel {...componentProps} />,
      bobbingCards: <BobbingCards {...componentProps} />,
      shadowBGFooter: <ShadowBGFooter {...componentProps} />,
      // defaultHeader: <DefaultHeader {...componentProps} />,
      defaultBanner: <DefaultBanner {...componentProps} />,
      defaultBannerPlayer: <DefaultBannerPlayer {...componentProps} />,
      defaultSwimlane: <DefaultSwimlane {...componentProps} />,
      uiMediaHeader: <UIMediaHeader {...componentProps} />,
      UIMediaFooter: <UImediaFooter {...componentProps} />,
      defaultFooter: <DefaultFooter {...componentProps} />,
      // uiMediaHeader: <UIMediaHeader {...componentProps} />,
      atgHeader: <ATGHeader {...componentProps} />,
      artistSwimlane: <DefaultArtistSwimlane {...componentProps} />,
      venueSwimlane: <DefaultVenueSwimlane {...componentProps} />,
      miamiFoxHeader: <MiamiFoxHeader {...componentProps} />,
      miamiFoxFooter: <MiamiFoxFooter {...componentProps} />,
    }

    return componentObj[key]
  }

  const getModal = (selectedModalObj) => {
    const { keyID } = selectedModalObj

    const selectedComponent = componentData.find((info) => info?.data?.id === keyID)
    // console.log('selectedComponent', selectedComponent, keyID, selectedModalObj)
    let modalProps = {
      componentData: selectedComponent?.data,
      modifyData: modifyComponent,
      modalSpecificData: selectedModalObj,
      onCancel: () => setModalState({}),
      isAdvancedEditAllowed: accountObj?.od_resource_allowances?.advance_component_edit,
    }
    if (selectedComponent) {
      let modalObj = {
        opaqueHeader: <RosemaryHeaderModal {...modalProps} />,
        rowingHeroSection: <RosemaryCarouselModal {...modalProps} />,
        asymmetricFlow: <RosemaryToptrendingModal {...modalProps} />,
        promotionalLead: <RosemaryMomentModal {...modalProps} />,
        passimCarve: <RosemaryRecentStoriesModal {...modalProps} />,
        passimCarvePlayer: <PassimCarvePlayerModal {...modalProps} />,
        inventorySlide: <RosemaryCategoriesModal {...modalProps} />,
        parallelFooter: <RosemaryFooterModal {...modalProps} />,
        crystallineHeader: <FitnessHeaderModal {...modalProps} />,
        classyBanners: <FitnessHeroModal {...modalProps} />,
        classyBannersPlayer: <ClassyBannerPlayerModal {...modalProps} />,
        narrowAdmonition: <FitnessYogaAdModal {...modalProps} />,
        definityCards: <FitnessClassesModal {...modalProps} />,
        fineTunedGallery: <FitnessPlansModal {...modalProps} />,
        flyerIntro: <FitnessTrainerModal {...modalProps} />,
        mementoSlides: <FitnessGalleriesModal {...modalProps} />,
        wedgedInfo: <FitnessPackagesModal {...modalProps} />,
        conventionalFooter: <FitnessFooterModal {...modalProps} />,
        decomposedBanners: <DecomposedBannersModal {...modalProps} />,
        extensiveCarouselRendition: <ExtensiveCarouselRenditionModal {...modalProps} />,
        adNCarousel: <AdNCarouselModal {...modalProps} />,
        extensiveCarousel: <ExtensiveCarouselSimpleModal {...modalProps} />,
        tripleCardCarousel: <TripleCardCarouselModal {...modalProps} />,
        bobbingCards: <BobbingCardsModal {...modalProps} />,
        shadowBGFooter: <ShadowBGFooterModal {...modalProps} />,
        // defaultHeader: <DefaultHeaderModal {...modalProps} />,
        defaultBanner: <DefaultBannerModal {...modalProps} />,
        defaultBannerPlayer: <DefaultBannerPlayerModal {...modalProps} />,
        defaultSwimlane: <DefaultSwimlaneModal {...modalProps} />,
        uiMediaHeader: <UIMediaHeaderModal {...modalProps} />,
        UIMediaFooter: <UImediaFooterModal {...modalProps} />,
        defaultFooter: <DefaultFooterModal {...modalProps} />,
        // uiMediaHeader: <UIMediaHeaderModal {...modalProps} />,
        atgHeader: <ATGHeaderModal {...modalProps} />,
        artistSwimlane: <DefaultArtistSwimlaneModal {...modalProps} />,
        venueSwimlane: <DefaultVenueSwimlaneModal {...modalProps} />,
        miamiFoxHeader: <MiamiFoxHeaderModal {...modalProps} />,
        miamiFoxFooter: <UImediaFooterModal {...modalProps} />,
      }
      return modalObj[selectedComponent.data.component_key]
    }
  }

  const modifyComponent = (keyID, data) => {
    const selectedComponent = componentData.find((info) => info.data.id === keyID)

    console.log('keyID, data', keyID, data)

    if (selectedComponent) {
      selectedComponent.data.data = data
      setComponentData([...componentData], selectedComponent)
      setModalState({})
    }
  }

  const addComponent = (componentInfo) => {
    let componentId = addModalState.keyID
    const componentIndex = componentData.findIndex((info) => info.data?.id === componentId)
    let tempComponentArr = componentData
    if (componentIndex > -1 && componentInfo) {
      let newComponentObj = JSON.parse(
        JSON.stringify({
          ...componentInfo,
          data: {
            ...componentInfo.data,
            id: uuid(),
          },
        }),
      )

      tempComponentArr.splice(componentIndex + 1, 0, newComponentObj)
    }
    setComponentData([...tempComponentArr])
  }

  const handleCloseEditor = () => {
    history.push('/templates')
  }

  return (
    <div>
      <div
        style={{ backgroundColor: '#f5f3f3' }}
        className="d-flex justify-content-between align-items-center h-100 px-5 border py-3"
      >
        <div style={{ width: '30%' }} className="d-flex align-items-center">
          <Dropdown align="end" className="">
            <Dropdown.Toggle
              style={{
                background: 'white',
                color: 'gray',
                boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.31)',
              }}
              className="border-0 btn-focus-none d-flex align-items-center"
            >
              <img src={themeIcon} alt="ThemeIcon" className="mx-2" />
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ fontSize: '13px' }}>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(0)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 0 && <img className="mx-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 0 && 'ml-5'} `}>
                      Default Theme
                    </span>
                  </div>
                  <img className="mx-2" src={DefaultThemeIcon} alt="DefaultThemeIcon" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(1)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 1 && <img className="mr-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 1 && 'ml-5'} `}>
                      Magenta Highlight
                    </span>
                  </div>
                  <img className="mx-2" src={MagentaIcon} alt="MagentaIcon" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(2)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 2 && <img className="mx-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 2 && 'ml-5'} `}>
                      Neon Dark
                    </span>
                  </div>
                  <img className="mx-2" src={NeonDarkIcon} alt="MagentaIcon" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(3)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 3 && <img className="mx-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 3 && 'ml-5'} `}>
                      Pantone Red
                    </span>
                  </div>
                  <img className="mx-2" src={PantoneRedIcon} alt="MagentaIcon" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(4)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 4 && <img className="mx-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 4 && 'ml-5'} `}>
                      Dark Infra Red
                    </span>
                  </div>
                  <img className="mx-2" src={DarkInfraIcon} alt="MagentaIcon" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item style={{ padding: '6px 5px' }}>
                <div onClick={() => setThemeIndex(5)} className="d-flex justify-content-between">
                  <div>
                    {themeIndex === 5 && <img className="mx-1" src={GreenTick} alt="GreenTick" />}
                    <span style={{ fontSize: '13px' }} className={`${themeIndex !== 5 && 'ml-5'} `}>
                      Green Energy
                    </span>
                  </div>
                  <img className="mx-2" src={GreenEnergyIcon} alt="MagentaIcon" />
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {premiumComponentExist && (
            <div className="message-text error-message mx-3">
              <p style={{ fontSize: '0.729vw' }}>
                * Premium Components are added. Buy now to publish.
              </p>
            </div>
          )}
        </div>
        <div style={{ width: '35%' }} className="text-center">
          <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>{templateData?.name}</span>
          <CFormText>
            Page status: {templateData?.is_published ? 'Published' : 'Unpublished'}
          </CFormText>
        </div>
        <div style={{ width: '35%' }} className=" d-flex justify-content-end">
          <CButton
            className="mx-3 bg-black rounded-1 btn-focus-none"
            onClick={() =>
              updateTemplate({
                name: templateData?.name,
                components: componentData,
                selected_theme: { ...themes[themeIndex] },
              })
            }
          >
            Save in Draft
          </CButton>
          <CButton
            className="mx-3 bg-black rounded-1 btn-focus-none"
            onClick={
              // downloadImage()
              () =>
                updateTemplate({
                  name: templateData?.name,
                  components: componentData,
                  is_published: true,
                  selected_theme: { ...themes[themeIndex] },
                })
            }
            style={{ opacity: premiumComponentExist ? '0.3' : '1' }}
            disabled={premiumComponentExist}
          >{`Save & Publish`}</CButton>
          <img
            src={CloseIcon}
            alt="CloseIcon"
            className="mx-4 cursor-pointer"
            onClick={() => setEditorCloseModal(true)}
          />
        </div>
      </div>
      <div className="flex justify-content-center ">
        <div
          id="templateRef"
          ref={templateRef}
          className="static-scrollbar-class position-relative"
          style={{ maxHeight: '90vh', width: '100%', background: '#1b242f' }}
        >
          <ThemeProvider theme={themes[themeIndex]}>
            <div style={{ background: themes[themeIndex]?.c1 }}>
              {componentData.map((info, index) => {
                const isPremiumComponent = checkPremiumComponentId(info._id)
                return (
                  <div className="position-relative" key={index}>
                    {isPremiumComponent && (
                      <div
                        className="position-absolute top-0 text-white rounded-lg"
                        style={{
                          fontSize: '1.302vw',
                          fontWeight: 'bold',
                          zIndex: '60',
                          marginTop: '4px',
                          left: '3.8vw',
                          backgroundColor: '#00000040',
                          padding: '0.416vw 0.729vw 0.364vw',
                        }}
                      >
                        PREMIUM COMPONENT
                      </div>
                    )}
                    {getComponent(info.data.component_key, info.data)}
                  </div>
                )
              })}
            </div>
          </ThemeProvider>
        </div>
      </div>
      {!isEmpty(modalState) && getModal(modalState)}
      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to delete this Component ?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setSelectedComponentId('')
            setDeleteModal(false)
          }}
          onConfirm={onDeleteComponent}
        />
      )}
      {editorCloseModal && (
        <DeleteModal
          openModal={editorCloseModal}
          title={`Are you sure you want to Close the Editor ?`}
          confirmButtonText={`Yes`}
          onCancel={() => setEditorCloseModal(false)}
          onConfirm={handleCloseEditor}
        />
      )}
      {!isEmpty(addModalState) && (
        <AddSectionModal
          data={baseComponentList?.data || []}
          onCancel={() => setAddModalState({})}
          onAdd={addComponent}
        />
      )}
    </div>
  )
}

export default TemplateEditor
